import Button from "@material-ui/core/Button";
import React, { useEffect, useState, useCallback } from "react";
import {
  useRecordContext,
  TopToolbar,
  ReferenceField,
  TextField,
  useDataProvider,
  showNotification,
  useShowController,
  FunctionField,
} from "react-admin";
import marker from "assets/images/marker.svg";
import historyImage from "assets/images/history.svg";
import { connect } from "react-redux";
import GoogleMapReact from "google-map-react";
import moment from "moment";
import { getDataFromJson } from "utils/tools";

import Nouislider, { Formatter } from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import "./assignment.scss";

//@ts-ignore
import { GridShowLayout, RaGrid } from "ra-compact-ui";
import { Box, makeStyles, Typography } from "@material-ui/core";
import CustomTimelineBusServices from "./components/CustomTimelineBusServices";
import Marker from "./components/Marker";
import BackupOperatorChipField from "./components/BackupOperatorChipField";
import DriverWithPhoneField from "./components/DriverWithPhoneField";
import StatusField from "../../components/StatusField";
import TypeField from "../../components/TypeField";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import { orderBy } from "lodash";
import ShowWrapper from "../../components/ShowWrapper";
import PermissionLoading from "../../components/PermissionLoading";
import CustomLabeled from "components/layout/CustomLabeled";
import Stack from "../../components/Stack";
import UpdatedByField from "../../components/UpdatedByField";
import CustomBooleanField from "../../components/CustomBooleanField";
import SubcontractorWithSubconIdentifierField from "./components/SubcontractorWithSubconIdentifierField";
import AdhocOperatorInfo from "./components/AdhocOperatorInfo";
import { colors, getExistingRoutePolyline } from "pages/enhancedRoutePlans/tools";

interface IStatusParser {
  [x: string]: {
    status: string;
    notificationText: string;
    notificationErrorText: string;
  };
}

const useStyles = makeStyles({
  root: {
    padding: "0 !important",
    paddingTop: "0px !important",
  },
  detailAssignment: {
    padding: "10px 20px",
  },
  titleAssignment: {
    marginLeft: "16px !important",
    marginBottom: "-60px !important",
  },
  wrapper: {
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    boxShadow: "0 4px 8px rgb(0 0 0 / 3%)",
    marginBottom: 24,
  },
  childWrapper: {
    backgroundColor: "#FAFAFA",
    borderRadius: 10,
    boxShadow: "0 4px 8px rgb(0 0 0 / 3%)",
  },
  actionReady: {
    backgroundColor: "#4caf50",
  },
  actionStarted: {
    backgroundColor: "#1976d2",
  },
  actionEnded: {
    backgroundColor: "#7c4dff",
  },
  actionCancel: {
    backgroundColor: "#f44336",
  },
  actionAssign: {
    backgroundColor: "#ffd600",
    color: "#000",
  },
  bottonShowMap: {
    marginBottom: 20,
  },
  actionSubcontractorTimesheet: {
    backgroundColor: "#00bcd4",
  },
  actionSubcontractorFinance: {
    backgroundColor: "#2a9df4",
  },
});

const statusParser: IStatusParser = {
  cancel: {
    status: "cancelled",
    notificationText: "Assignment Cancelled",
    notificationErrorText: "Cannot cancel assignment, please try again.",
  },
  start: {
    status: "started",
    notificationText: "Assignment Started",
    notificationErrorText: "Cannot start assignment, please try again.",
  },
  end: {
    status: "ended",
    notificationText: "Assignment Finished",
    notificationErrorText: "Cannot finish assignment, please try again.",
  },
  ready: {
    status: "ready",
    notificationText: "Assignment set to Ready",
    notificationErrorText: "Cannot set ready assignment, please try again.",
  },
};

/**
 * Action buttons for Order Show
 *
 * @param param0
 */
const OrderShowActions = connect(undefined, { showNotification })(({
  history,
  record,
  ...props
}: any) => {
  const provider = useDataProvider();
  const classes = useStyles();

  const _changeStatus = async (to: string) => {
    const { id, driverId, vehicleId } = record;
    const data =
      to === "start" ? { driverId, vehicleId, driverType: "driver" } : {};

    try {
      await provider.customUpdate(`assignments/${id}/${to}`, {
        id,
        data,
      });

      props.showNotification(statusParser[to].notificationText);
      setTimeout(() => {
        window.location.reload();
      }, 200);
    } catch (error: any) {
      props.showNotification(
        `${statusParser[to].notificationErrorText} Error Message : ${error.message}`,
        "warning",
      );
    }
  };

  const goToSubcontractorTimesheet = async (assignmentId: number) => {
    try {
      const timesheets = await provider.getList("subcontractorTimesheets", {
        pagination: { page: 1, perPage: 1 }, // Assume 1 subcontractor timesheet only has 1 assignment
        sort: { field: "", order: "" },
        filter: {
          AssignmentId: assignmentId,
        },
      });

      if (timesheets.data.length === 0) {
        throw new Error("Assignment not found");
      }

      // Assume 1 subcontractor timesheet only has 1 assignment
      const url = `/#/subcontractorTimesheets/${timesheets.data[0].id
        }?adhocSubcontractorId=${Number(record.adhocSubcontractorId)}`;
      window.open(url, "_blank");
    } catch (error: any) {
      if (error.status === 404) {
        error.message = "Assignment not found";
      }

      props.showNotification(`Error Message : ${error.message}`, "warning");
    }
  };

  const goToSubcontractorFinance = (subcontractorId: number) => {
    const url = `/#/subcontractors/${subcontractorId}/show/2`;
    window.open(url, "_blank");
  };

  return (
    <TopToolbar>
      {record?.assignedSubcontractor && (
        <Button
          color="primary"
          variant="contained"
          onClick={() =>
            goToSubcontractorFinance(
              Number(record.assignedSubcontractor?.subcontractorId),
            )
          }
          className={classes.actionSubcontractorFinance}
        >
          Subcontractor Finance
        </Button>
      )}
      <Button
        color="primary"
        variant="contained"
        onClick={() => goToSubcontractorTimesheet(Number(record.id))}
        className={classes.actionSubcontractorTimesheet}
      >
        Subcontractor Timesheet
      </Button>
      <Button
        color="primary"
        variant="contained"
        onClick={() => history.push(`/assignments/${record.id}/edit`)}
        className={classes.actionAssign}
      >
        Assign/Unassign
      </Button>
      <Button
        color="primary"
        variant="contained"
        onClick={() => _changeStatus("ready")}
        className={classes.actionReady}
      >
        Set Ready
      </Button>

      <Button
        color="primary"
        variant="contained"
        onClick={() => _changeStatus("cancel")}
        className={classes.actionCancel}
      >
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        onClick={() => _changeStatus("start")}
        className={classes.actionStarted}
      >
        Start
      </Button>

      <Button
        color="primary"
        variant="contained"
        onClick={() => _changeStatus("end")}
        className={classes.actionEnded}
      >
        End
      </Button>
    </TopToolbar>
  );
});

/**
 * Display details of orders
 * @param props
 */
const AssignmentShow = (props: any) => {
  const { history } = props;
  const classes = useStyles();
  const [isShowMap, setIsShowMap] = useState(true);
  const { record, loading } = useShowController(props);
  if (loading) {
    return <PermissionLoading />;
  }

  const formatter = (data: any) => {
    if (data && !data.__formatted) {
      // guard against re-processing
      data.estimatedStartAt = moment(data.estimatedStartedAt).format(
        "DD / MM / YYYY, hh:mm A",
      );
      data.estimatedEndAt = moment(data.estimatedEndedAt).format(
        "DD / MM / YYYY, hh:mm A",
      );
      data.startAt = data.startedAt
        ? moment(data.startedAt).format("DD / MM / YYYY, hh:mm A")
        : "-";
      data.endAt = data.endedAt
        ? moment(data.endedAt).format("DD / MM / YYYY, hh:mm A")
        : "-";

      data.subcontractorStartDate = data.assignedSubcontractor?.startDate
        ? moment(data.assignedSubcontractor?.startDate).format("DD / MM / YYYY")
        : "-";
      data.subcontractorEndDate = data.assignedSubcontractor?.endDate
        ? moment(data.assignedSubcontractor?.endDate).format("DD / MM / YYYY")
        : "-";

      data.startTime = moment(data.estimatedStartedAt).format("hh:mm A");
      data.endTime = moment(data.estimatedEndedAt).format("hh:mm A");

      data.takingCount = 0;
      data.absentCount = 0;
      data.notTakingCount = 0;
      data.totalCount = 0;

      if (data.locations) {
        // Trim based on routeType — but only if not already trimmed
        // We identify the school location by checking if there is no passenger in the location
        // Because the old Assignment data don't have the school location
        if (data.routeType === "to_school" && data.locations[data.locations.length - 1].passengers.length === 0) {
          data.locations = data.locations.slice(0, -1);
        } else if (
          (data.routeType === "from_school" ||
            data.routeType === "cca") &&
          data.locations[0].passengers.length === 0
        ) {
          data.locations = data.locations.slice(1);
        }

        data.locations.forEach((location: any, index: number) => {
          // convert ASCII Code into Alphabet
          // 65 === A
          const locationCode = String.fromCharCode(65 + index);

          // We re-order the order number base on the trimmed locations
          location.order = index + 1;

          location.arrivAt = moment(location.estimatedArrivedAt).format(
            "hh:mm A",
          );
          location.departAt = moment(location.departedAt).format("hh:mm A");

          location.passengers
            .sort((a: any, b: any) => a.id - b.id)
            .forEach((passenger: any, index: number) => {
              passenger.locationCode = `${locationCode}${index + 1}`;

              data.totalCount += 1;
              if (passenger.logs.length > 0) {
                const sortedLogs = orderBy(
                  passenger.logs,
                  ["loggedAt"],
                  ["desc"],
                );

                if (
                  sortedLogs[0].type === "boarded" ||
                  sortedLogs[0].type === "alighted"
                ) {
                  data.takingCount += 1;

                  if (sortedLogs[0].type === "boarded") {
                    passenger.status = "ON THE BUS";
                  } else {
                    passenger.status = "ALIGHT";
                  }
                }

                if (sortedLogs[0].type === "absented") {
                  data.absentCount += 1;
                  passenger.status = "ABSENT";
                }

                if (sortedLogs[0].type === "not_taking") {
                  data.notTakingCount += 1;
                  passenger.status = "NOT TAKING";
                }

                if (sortedLogs[0].type === "exclude_student") {
                  data.notTakingCount += 1;
                  passenger.status = "EXCLUDE STUDENT";
                }
              } else {
                passenger.status = "NOT STARTED";
              }
            });
        });
      }

      data.__formatted = true; // mark as processed
    }

    return data;
  };

  const breadcrumb = [
    { link: "/assignments", title: "Bus Services" },
    { link: `/assignments/${props.id}/show`, title: props.id },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        customName={{
          resourceName: "Bus Services",
          propertyName: "routeName",
        }}
        actions={
          <OrderShowActions history={history} record={record} {...props} />
        }
        component="div"
        {...props}
      >
        <GridShowLayout className={classes.root} record={formatter(record)}>
          <RaGrid container>
            <RaGrid item xs={12} className={classes.wrapper}>
              <AdhocOperatorInfo />
              <RaGrid container className={classes.detailAssignment}>
                <RaGrid item xs={3}>
                  <Stack direction="column" alignItems="flex-start">
                    <CustomLabeled name="Assignment Date">
                      <TextField source="estimatedStartAt" emptyText="-" />
                    </CustomLabeled>
                    <FunctionField
                      label="Start By"
                      render={(record: any) => (
                        <UpdatedByField
                          record={record}
                          data={record.startedBy}
                          referenceSource="startedBy.id"
                        />
                      )}
                    />
                    <CustomLabeled name="Start At">
                      <TextField source="startAt" emptyText="-" />
                    </CustomLabeled>
                    <FunctionField
                      label="End By"
                      render={(record: any) => (
                        <UpdatedByField
                          record={record}
                          data={record.endedBy}
                          referenceSource="endedBy.id"
                        />
                      )}
                    />
                    <CustomLabeled name="End At">
                      <TextField source="endAt" emptyText="-" />
                    </CustomLabeled>
                    <CustomLabeled name="Route Type">
                      <TypeField source="routeType" type="busSchedule" />
                    </CustomLabeled>
                    <CustomLabeled name="Dry Run Assignment">
                      <CustomBooleanField
                        source="isDryRun"
                        textForTrueValue="Yes"
                        textForFalseValue="No"
                      />
                    </CustomLabeled>
                    <FunctionField
                      addLabel={false}
                      render={(record: any) =>
                        record?.routeType === "to_school" &&
                          record?.arrivalStatus ? (
                          <CustomLabeled name="Arrival Status">
                            <StatusField
                              record={record}
                              source="arrivalStatus"
                            />
                          </CustomLabeled>
                        ) : (
                          <></>
                        )
                      }
                    />
                  </Stack>
                </RaGrid>

                <RaGrid item xs={3}>
                  <Stack direction="column" alignItems="flex-start">
                    <CustomLabeled name="Assignment Status">
                      <StatusField source="status" />
                    </CustomLabeled>

                    <CustomLabeled name="All Students">
                      <FunctionField
                        render={(record: any) => (
                          <>
                            <Typography variant="subtitle2">
                              {record.takingCount} / {record.totalCount}
                            </Typography>
                          </>
                        )}
                      />
                    </CustomLabeled>

                    <CustomLabeled name="Absent">
                      <TextField source="absentCount" emptyText="-" />
                    </CustomLabeled>

                    <CustomLabeled name="Not Taking">
                      <TextField source="notTakingCount" emptyText="-" />
                    </CustomLabeled>
                  </Stack>
                </RaGrid>

                <RaGrid item xs={3}>
                  <Stack direction="column" alignItems="flex-start">
                    <CustomLabeled name="Assigned Vehicle">
                      <ReferenceField
                        source="vehicleId"
                        reference="vehicles"
                        link="show"
                        emptyText="-"
                      >
                        <FunctionField
                          render={(record: any) =>
                            `${record?.plateNumber} - ${record?.seatCapacity != null
                              ? `${record.seatCapacity} seat(s)`
                              : `No seat capacity info available`
                            }`
                          }
                        />
                      </ReferenceField>
                    </CustomLabeled>

                    <CustomLabeled name="Assigned Driver">
                      <ReferenceField
                        source="driverId"
                        reference="drivers"
                        link="show"
                      >
                        <DriverWithPhoneField />
                      </ReferenceField>
                    </CustomLabeled>

                    <CustomLabeled name="Assigned Bus Assistant">
                      <ReferenceField
                        label=""
                        source="busAssistantId"
                        reference="busAssistants"
                        link="show"
                      >
                        <DriverWithPhoneField />
                      </ReferenceField>
                    </CustomLabeled>

                    <CustomLabeled name="Backup Drivers">
                      <BackupOperatorChipField
                        source="backupDrivers"
                        chipSource="fullName"
                      />
                    </CustomLabeled>

                    <CustomLabeled name="Backup Vehicles">
                      <BackupOperatorChipField
                        source="backupVehicles"
                        chipSource="plateNumber"
                      />
                    </CustomLabeled>

                    <CustomLabeled name="Backup Bus Assistants">
                      <BackupOperatorChipField
                        source="backupBusAssistants"
                        chipSource="fullName"
                      />
                    </CustomLabeled>
                  </Stack>
                </RaGrid>

                <RaGrid item xs={3}>
                  <Stack direction="column" alignItems="flex-start">
                    <CustomLabeled name="Assigned Subcontractor">
                      <ReferenceField
                        source="assignedSubcontractor.subcontractorId"
                        reference="subcontractors"
                        link={false}
                        emptyText="-"
                      >
                        <SubcontractorWithSubconIdentifierField />
                      </ReferenceField>
                    </CustomLabeled>

                    <CustomLabeled name="Vehicle Size">
                      <TextField
                        source="assignedSubcontractor.vehicleSize"
                        emptyText="-"
                      />
                    </CustomLabeled>

                    <CustomLabeled name="Subcontractor Start Date">
                      <TextField
                        source="subcontractorStartDate"
                        emptyText="-"
                      />
                    </CustomLabeled>

                    <CustomLabeled name="Subcontractor End Date">
                      <TextField source="subcontractorEndDate" emptyText="-" />
                    </CustomLabeled>
                  </Stack>
                </RaGrid>
              </RaGrid>
            </RaGrid>

            <RaGrid item xs={12} className={classes.wrapper}>
              <RaGrid container className={classes.detailAssignment}>
                <Typography variant="h6">Bus Services Detail</Typography>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    setIsShowMap(!isShowMap);
                  }}
                  startIcon={<AutorenewIcon />}
                >
                  {isShowMap ? "Hide Map" : "Show Map"}
                </Button>
                <RaGrid container>
                  <RaGrid item lg={isShowMap ? 5 : 12} md={12} xs={12}>
                    <CustomTimelineBusServices
                      source="locations"
                      assignmentId={props.id}
                    />
                  </RaGrid>
                  {isShowMap ? (
                    <RaGrid item lg={7} md={12} xs={12}>
                      <Maps resource />
                    </RaGrid>
                  ) : (
                    <></>
                  )}
                </RaGrid>
              </RaGrid>
            </RaGrid>
          </RaGrid>
        </GridShowLayout>
      </ShowWrapper>
    </>
  );
};

const Maps = ({ ...props }: any) => {
  const record = useRecordContext(props);
  const [mapInstance, setMapInstance] = useState<any>(null);
  const [mapsLayoutInstance, setMapsLayout] = useState<any>(null);
  const [markerLocation, setMarkerLocation] = useState({ Lat: 0, Lng: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [tripHistory, setTripHistory] = useState([]);
  const [plannedRoutes, setPlannedRoutes] = useState([]);

  useEffect(() => {
    if (record) {
      if (record.tripHistoryUrl) {
        setIsLoading(true);
        getDataFromJson(record.tripHistoryUrl).then((res: any) => {
          if (res) {
            setTripHistory(res?.json);
          }
          setIsLoading(false);
        });
      }

      if (record.routeGeometries && record.routeGeometries.length > 0) {
        const promises = record.routeGeometries.map((routeGeometry: any) =>
          getExistingRoutePolyline(routeGeometry.polyline)
        );

        Promise.all(promises).then((results: any[]) => {
          const allPolylines = results.flat();
          setPlannedRoutes(allPolylines);
        });
      }
    }
  }, [record]);

  useEffect(() => {
    if (mapInstance !== null && mapsLayoutInstance !== null) {
      tripHistory.forEach((item: any, index: number) => {
        let path = null;
        if (index !== 0) {
          const prevItem = tripHistory[index - 1];
          path = [
            { lat: Number(prevItem.Lat), lng: Number(prevItem.Lng) },
            { lat: Number(item.Lat), lng: Number(item.Lng) },
          ];
          const line = new mapsLayoutInstance.Polyline({
            path,
            strokeColor: "#ff5722",
          });
          line.setMap(mapInstance);
        }
      });

      let geodesicPolyline = new mapsLayoutInstance.Polyline({
        path: plannedRoutes,
        strokeColor: colors[0].colorOne
      });
      geodesicPolyline.setMap(mapInstance);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapInstance, mapsLayoutInstance]);

  const handleApiLoaded = useCallback(
    (map: any, maps: any) => {
      // use map and maps objects

      setMapInstance(map);
      setMapsLayout(maps);
    },
    [setMapInstance, setMapsLayout],
  );

  const renderMarker = useCallback((record) => {
    if (record) {
      if (record.locations) {
        return record.locations.map((item: any) => {
          return <Marker lat={item.lat} lng={item.lng} resource={item} />;
        });
      }
    }
  }, []);

  const renderSchoolMarker = useCallback((record) => {
    if (record) {
      if (record.school) {
        return (
          <Marker
            lat={record.school.lat}
            lng={record.school.lng}
            resource={record.school}
            isSchool
          />
        );
      }
    }
  }, []);

  const onSliderUpdate = useCallback(
    (index: any) => {
      if (tripHistory.length !== 0) {
        const item = tripHistory[Number(index)];
        setMarkerLocation({
          Lat: item.Lat,
          Lng: item.Lng,
        });
      }
    },
    [tripHistory],
  );

  const rangeFormatter = useCallback(
    (value: any) => {
      if (tripHistory[value]) {
        return moment(tripHistory[value].CreatedAt).format(
          "DD / MM / YYYY hh:mm A",
        );
      }
      return "";
    },
    [tripHistory],
  );

  const tooltip: Formatter = {
    from: Number,
    to: (value: number): string => {
      if (tripHistory[Number(value)]) {
        const item = tripHistory[Number(value)];
        return `Latitude: ${item.Lat}\n\n Longitude: ${item.Lng
          } \n\n Time: ${moment(item.CreatedAt).format(
            "DD / MM / YYYY hh:mm A",
          )}`;
      }
      return "";
    },
  };

  if (tripHistory.length === 0) {
    return (
      <div className="TripHistoryContainer">
        {isLoading ? (
          <p className="TripHistory-Indicator">Loading trip history data...</p>
        ) : (
          <>
            <img
              className="TripHistory-Icon"
              src={historyImage}
              alt="History Not Found"
            />
            <p className="TripHistory-Indicator">
              Trip history not available, try again later.
            </p>
          </>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="TripHistoryContainer">
        <GoogleMapReact
          bootstrapURLKeys={{
            key: "AIzaSyDYGvy_HvsUfvJ_7_d4PmOH201jIFNn-iM",
          }}
          defaultCenter={{
            lat: 1.415039,
            lng: 103.807996,
          }}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
          defaultZoom={13}
        >
          {renderMarker(record)}
          {renderSchoolMarker(record)}
          <BusMarker lat={markerLocation.Lat} lng={markerLocation.Lng} />
        </GoogleMapReact>
      </div>
      {tripHistory.length > 1 && (
        <Nouislider
          style={{
            marginLeft: 50,
            marginRight: 50,
            marginBottom: 50,
            marginTop: 20,
          }}
          onUpdate={onSliderUpdate}
          step={1}
          pips={{
            mode: "range",
            density: 2,
            format: {
              to: rangeFormatter,
            },
          }}
          range={{
            min: 0,
            max: tripHistory.length - 1,
          }}
          start={0}
          tooltips={[tooltip]}
          connect
        />
      )}

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginTop: "20px",
          marginLeft: "20px",
        }}
      >
        <Box style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Box
            style={{
              width: "24px",
              height: "4px",
              backgroundColor: colors[0].colorOne,
              borderRadius: "2px",
            }}
          />
          <Typography variant="body2" style={{ color: "#2B3674" }}>
            Planned Routes
          </Typography>
        </Box>
        <Box style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Box
            style={{
              width: "24px",
              height: "4px",
              backgroundColor: "#ff5722",
              borderRadius: "2px",
            }}
          />
          <Typography variant="body2" style={{ color: "#2B3674" }}>
            Real Routes
          </Typography>
        </Box>
      </Box>
    </>
  );
};

const BusMarker = (_props: any) => {
  return (
    <div className="Marker-Wrapper">
      <img className="Marker-Icon" src={marker} alt="Bus Marker" />
    </div>
  );
};
export default AssignmentShow;
